import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'

import 'config/reactotron'
import store, { persistor } from 'store'
import DefaultLayout from 'layout/Default'
import { Spinner } from 'components'

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <PersistGate loading={<Spinner active opacity={1} />} persistor={persistor}>
                    <DefaultLayout />
                </PersistGate>
            </Provider>
        )
    }
}

export default App



// WEBPACK FOOTER //
// src/App.js